import { View, Text } from "@react-pdf/renderer";
import { getRubricVerdict } from "components/dashboard/body/projects/panels/coverage/coverage.constants";
import { getRubricAverage } from "components/dashboard/body/projects/panels/coverage/utils/rubricScore";
import { COVERAGE_RECOMMENDATION_LABELS } from "components/dashboard/body/projects/panels/coverage/utils/coverageRecommendation";
import { CoverageSummaryPDFPropsType } from "./CoverageSummaryPDF.types";
import { styles } from "./CoverageSummaryPDF.styles";

const formatRecommendation = (value?: string | null) => {
  if (!value || !(value in COVERAGE_RECOMMENDATION_LABELS)) {
    return "-";
  }
  return COVERAGE_RECOMMENDATION_LABELS[value as keyof typeof COVERAGE_RECOMMENDATION_LABELS];
};

export const CoverageSummaryPDF: CoverageSummaryPDFPropsType = ({ coverage }) => {
  const rubricAverage = getRubricAverage(coverage.rubric);
  const verdict = getRubricVerdict(rubricAverage);

  return (
    <View style={styles.view}>
      <View style={styles.heroBlock}>
        <Text style={styles.titleText}>{coverage.title || "-"}</Text>
        <View style={styles.metaRow}>
          <View style={styles.recColumn}>
            <Text style={styles.recLine}>
              Script: {formatRecommendation(coverage.script_recommendation)}
            </Text>
            <Text style={styles.recLine}>
              Writer: {formatRecommendation(coverage.writer_recommendation)}
            </Text>
          </View>
          <View style={styles.scoreColumn}>
            <Text style={styles.scoreValue}>
              {rubricAverage !== null ? rubricAverage.toFixed(1) : "—"}
            </Text>
            <Text style={styles.scoreLabel}>/ 4{verdict ? ` · ${verdict.label}` : ""}</Text>
          </View>
        </View>
      </View>
      <View style={styles.table}>
        <View style={styles.thead}>
          <Text style={styles.theadText}>Synopsis</Text>
        </View>
        <View style={styles.tbody}>
          <Text style={styles.text}>{coverage.analysis.summary || "-"}</Text>
        </View>
      </View>
    </View>
  );
};

export default CoverageSummaryPDF;
